import React, { useContext, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Dropdown, Tag, Toast } from 'primereact'


import Card from '../../../Base/Components/Card/Card'
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek'
import { getDateProduction } from '../../../Base/Services/FechasService'
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid'
import { toastShow } from '../../../Base/Services/ToastService'
import { setTitlePage } from '../../../Base/Services/Config/ConfigService'

import { getPublicVehiculosPPF } from '../../../API/Logistica/Vehiculos/VehiculosRequets'
import { getPublicMotoristasPPF } from '../../../API/Logistica/Motoristas/MotoristasRequest'
import { ChangeMotoVehi, ChangePermisoProgramacionMotoristas, getPublicALListProgramacionMotoristas, getPublicListProgramacionMotoristas } from '../../../API/Logistica/Motoristas/SolicitudMotoristasRequests'

import CrearSolicitudMotorista from './new/CrearSolicitudMotorista'
import CalendarProgramacionMotoristas from './Calendar/CalendarProgramacionMotoristas'
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext'
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext'
import { decodeToken } from 'react-jwt'



const ServiciosMotoristasScreen = () => {


    const toast = useRef(null);

    const { userAuth } = useContext(AuthContext);
    const { changeTheme } = useContext(ConfigContext);

    const params = useParams();
    let { token } = params;
    if (!token) {
        token = userAuth.Token;
    }


    const [date, setDate] = useState([new Date('01/01/2023'), new Date()]);
    const [loading, setLoading] = useState(false);
    const [showDialogNew, setShowDialogNew] = useState(false);
    const [data, setData] = useState([]);
    const [select, setSelect] = useState([]);
    const [edit, setEdit] = useState(null);
    const [editTrunk, setEditTrunk] = useState(false);
    const [accesos, setAccesos] = useState([]);
    const [showCalendar, setShowCalendar] = useState(false);
    const [vehiculos, setVehiculos] = useState([]);
    const [motoristas, setMotoristas] = useState([]);
    const [user, setUser] = useState(null);

    const getInfo = async () => {
        setLoading(true);
        setSelect([]);
        const v = await getPublicVehiculosPPF(token);
        const m = await getPublicMotoristasPPF(token);
        setMotoristas(m);
        setVehiculos(v);
        const a = getDateProduction(date);
        let t = [];
        if(userAuth?.AccesosWeb?.split(',').map(e => parseInt(e)).includes(16)){
            setAccesos(userAuth?.AccesosWeb?.split(',')?.map(e => parseInt(e)));
            t = await getPublicALListProgramacionMotoristas({ fecha1: a[0], fecha2: a[1] }, token);
        }else{
            t = await getPublicListProgramacionMotoristas({ fecha1: a[0], fecha2: a[1] }, token);
        }
        setData(t);
        setLoading(false);
    }

    const changePermiso = async (value, { data }) => {
        setLoading(true)
        if (select.length > 0) {
            select.forEach(async (permiso) => {
                const t = await ChangePermisoProgramacionMotoristas({
                    IdProgramacion: permiso.IdProgramacion,
                    Permiso: permiso.Permiso1 ? false : true
                }, token)
                toastShow(toast, 'success', 'Permiso Actualizado')
            })
        } else {
            const t = await ChangePermisoProgramacionMotoristas({
                IdProgramacion: data.IdProgramacion,
                Permiso: data.Permiso1 ? false : true
            }, token)
            toastShow(toast, 'success', 'Permiso Actualizado')
        }
        getInfo();
        setLoading(false);
    }

    const onHideNew = () => {
        setShowDialogNew(false);
        setEditTrunk(false);
        setEdit(null)
        getInfo();
    }

    const onHideCalendar = () => {
        setShowCalendar(false);
    }

    const statusTemplate = (rowData) => {
        switch (rowData.IdEstado) {
            case 3619:
                return <Tag value={rowData.StatusName} ></Tag>
                break;
            case 3620:
                return <Tag value={rowData.StatusName} severity='info'></Tag>
                break;

            case 3621:
                return <Tag value={rowData.StatusName} severity='success'></Tag>
                break;
            case 3622:
                return <Tag value={rowData.StatusName} severity='danger'></Tag>
                break;
            case 3623:
                return <Tag value={rowData.StatusName}   style={{ background: '#FBBF2C'}}></Tag>
                break;
            case 3624:
                return <Tag value={rowData.StatusName}   style={{ background: '#9E9E9E'}}></Tag>
                break;
            case 3625:
                return <Tag value={rowData.StatusName}   style={{ background: '#FFE0C0'}}></Tag>
                break;

            default:
                break;
        }
    }

    const botones = (rowData) => {
        if(rowData.IdProgramacion){
        return <div className='d-fles' style={{ gap: 5 }}>
            <Button
                className='p-button-text'
                icon='pi pi-pencil'
                onClick={e => {
                    setEdit(rowData);
                    setShowDialogNew(rowData);
                }}
                disabled={![3619].includes(rowData.IdEstado)}
            />
            {accesos.includes(16) && <Button
                className='p-button-text'
                icon='pi pi-truck'
                onClick={e => {
                    setEdit(rowData);
                    setShowDialogNew(rowData);
                    setEditTrunk(true);
                }} 
                disabled={![3619, 3620, 3621].includes(rowData.IdEstado)}
                />}
        </div>
        }
    }

    const EditMotorista = (rowData) => {
        const [motorista] = motoristas.filter(e => e.IdMotorista === rowData.IdMotorista);
        const [editing, setEditing] = useState(false);
        const [value, setValue] = useState(motorista?.IdMotorista);
        return <div className='col-12' style={{ height: 20 }} onDoubleClick={e => { setEditing(true) }}>
            {editing && accesos.includes(16) ? <div className='col-12'>
                <Dropdown
                    className='col-12'
                    style={{ height: 30, fontSize: '10px !important' }}
                    value={value}
                    onChange={e => {
                        let ids = []
                        if(select.length > 0){
                            ids = select.map(e => e.IdProgramacion)
                        }else{
                            ids.push(rowData.IdProgramacion)
                        }
                        ChangeMotoVehi({
                            funcion: 1,
                            IdProgramacion: ids.toString(),
                            IdMotorista: e.target.value
                        }, token)
                        getInfo();
                        setValue(e.target.value);
                        setEditing(false);
                    }}
                    options={motoristas}
                    optionLabel='Nombre'
                    optionValue='IdMotorista'
                    filter
                />
            </div> : rowData?.Motorista}
        </div>
    }


    const EditVehiculo = (rowData) => {
        const [vehiculo] = vehiculos.filter(e => e.Idvehiculo === rowData.IdVehiculo);
        const [editing, setEditing] = useState(false);
        const [value, setValue] = useState(vehiculo?.Idvehiculo);
        return <div className='col-12' style={{ height: 20 }} onDoubleClick={e => { setEditing(true) }}>
            {editing && accesos.includes(16) ? <div className='col-12'>
                <Dropdown
                    className='col-12'
                    style={{ height: 30, fontSize: '10px !important' }}
                    value={value}
                    onChange={e => {
                        let ids = []
                        if(select.length > 0){
                            ids = select.map(e => e.IdProgramacion)
                        }else{
                            ids.push(rowData.IdProgramacion)
                        }
                        ChangeMotoVehi({
                            funcion: 2,
                            IdProgramacion: ids.toString(),
                            IdVehiculo: e.target.value
                        }, token)
                        getInfo();
                        setValue(e.target.value);
                        setEditing(false);
                    }}
                    options={vehiculos}
                    optionLabel='Vehiculo'
                    optionValue='Idvehiculo'
                    filter
                />
            </div> : rowData?.Vehiculo}
        </div>
    }

    const columns = [
        {
            header: 'Solicitud',
            field: 'IdProgramacion',
            Format: 'Template',
            body: e => e.IdProgramacion ? 'SM' + e.IdProgramacion?.toString().padStart(5, '0') : '',
            className: 'small',
            filter: true,
            frozen: true,
        },
        {
            header: 'Solicita',
            field: 'Solicita',
            className: 'medium',
            frozen: true,
        },
        {
            header: 'Estado',
            field: 'StatusName',
            Format: 'Template',
            body: statusTemplate,
            filter: true,
            className: 'Xsmall',
            frozen: true,
        },
        {
            header: 'Area',
            field: 'Area',
            className: 'medium',
        },
        {
            header: 'Creado',
            field: 'FechaCreadoWeb',
            className: 'medium'
        },
        {
            header: 'Fecha Actividad',
            field: 'FechaSolicitaWeb',
            className: 'medium'
        },
        {
            header: 'Direccion',
            field: 'Direccion',
            className: 'large'
        },
        {
            header: 'Descripcion',
            field: 'Descripcion',
            className: 'large'
        },
        {
            header: 'Motorista',
            field: 'Motorista',
            Format: 'Template',
            body: EditMotorista
        },
        {
            header: 'Vehiculo',
            field: 'Vehiculo',
            Format: 'Template',
            body: EditVehiculo
        },
        {
            header: 'Fecha Inicio',
            field: 'FechaInicioWeb',
        },
        {
            header: 'FechaFinWeb',
            field: 'FechaFinWeb',
        },
        {
            header: 'Comentario Motorista',
            field: 'ComentarioMotorista',
            className: 'large'
        },
        
        {
            header: 'User Auth',
            field: 'UserName1',
            className: 'small'
        },
        {
            header: 'Fecha Auth',
            field: 'FechaPermiso1Web',
            className: 'medium'
        },
        {
            header: 'Autorizado',
            field: 'Permiso1',
            Format: 'Checkbox',
            className: 'Xsmall',
            onChange: changePermiso,
            frozen: true,
            alignFrozen: 'right',
            disabled: accesos.includes(16)
        },
        {
            header: '',
            field: 'botones',
            Format: 'Template',
            body: botones,
            frozen: true,
            alignFrozen: 'right',
            className: 'Xsmall'
        },

    ]

    const table = {
        Columns: columns,
        Data: data,
        loading: loading,
        selected: select,
        setSelected: setSelect
    }

    useEffect(() => {
        getInfo();
        setTitlePage('Servicios de Motoristas')
        if(params?.token){
            changeTheme('Dark');
            const usuario = decodeToken(params?.token);
            console.log('usuario', usuario);
            setUser(usuario);
        }
    }, [])



    return (
        <div className='p-3'>
            <Toast ref={toast} />
            <Card
                titulo={<div style={{ display: 'flex', gap: 10 }}>
                    <h3>Servicios de Motorista</h3>
                    <CalendarWeek
                        date={date}
                        setDate={setDate}
                        loading={loading}
                        selectionMode='range'
                        buscar={getInfo}
                    />
                    <Button icon='pi pi-plus' onClick={e => { setShowDialogNew(true) }} />
                    {/* {accesos.includes(16) && <Button icon='pi pi-calendar' onClick={e => { setShowCalendar(true) }} />} */}
                </div>}
                contenido={<div className='pt-4' style={{ height: '90vh' }}>

                    <CrearSolicitudMotorista showDialog={showDialogNew} onHide={onHideNew} toast={toast} edit={edit} editTrunk={editTrunk} Usuario={user} />
                    <CalendarProgramacionMotoristas showCalendar={showCalendar} onHide={onHideCalendar} />

                    <AgGrid table={table} />
                </div>}
            />
        </div>
    )
}


export default ServiciosMotoristasScreen